import client from "../client";

export default function API() {
  return client
    .post(`members/update_member_ip_address`)
    .then((response) => response.data);
}
